import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useRouteStatus from '../../../hooks/useRouteStatus';
import useSession from '../../../hooks/useSession';
import useSessionEntity from '../../../hooks/useSessionEntity';
import Error from '../../shared/Error';
import Loading from '../../shared/Loading';
import Support from '../../shared/Support';

export default function PastDue({ location }) {
  const [, sessionActions] = useSession();

  const company = useSessionEntity('company');
  const user = useSessionEntity('user');

  useRouteStatus(location);

  useEffect(() => {
    sessionActions.finish();
  }, []);

  if (!user || !company)
    return <Loading className="w-14 h-14" containerClass="my-24 sm:my-0" />;

  return (
    <div role="main" className="mx-6 sm:mx-auto">
      <div className="my-4 flex items-center">
        <span className="fa-layers fa-fw text-5xl">
          <FontAwesomeIcon
            icon="square"
            className="!mx-0 text-background-error"
          />
          <FontAwesomeIcon
            icon={['far', 'triangle-exclamation']}
            className="text-3xl !mx-1.5 text-error"
          />
        </span>
        <div className="text-xl sm:text-4xl font-extrabold">
          Hi {user.first_name},
        </div>
      </div>

      <Error />

      <p className="font-light sm:text-lg tracking-wide mb-6">
        Unfortunately your account is past due. In order to continue using your
        line of credit, please contact Credit Key Support to resolve this issue.
      </p>

      <div className="mt-6 sm:mt-12">
        <Support />
      </div>
    </div>
  );
}
